// src/api/services/farm/imageService.js
import client from '../client';

const BASE = '/api/farms';


/** 1)  presigned URL + pending  */
export function initiateImageUpload(farmId, body) {
  return client
    .post(`${BASE}/${farmId}/image/upload-url`, body)
    .then(res => res.data);
}

/** 2) Upload cover image */
export function confirmCoverImageUpload(farmId, imageId) {
  return client
    .post(`${BASE}/${farmId}/image/${imageId}/confirm-cover-image`)
    .then(res => res.data);
}

/** 3) Upload images */
export function confirmGalleryUpload(farmId, imageIds) {
  return client
    .post(`${BASE}/${farmId}/images/confirm-gallery`, { imageIds })
    .then(res => res.data);
}

export function getImagesByImageIds(imageIds) {
  return client
    .post(`${BASE}/images/bulk-by-ids`, { imageIds })
    .then(res => res.data);
}

/** 4) Get cover image (presigned view URL) */
export function getCoverImage(farmId) {
  return client.get(`${BASE}/${farmId}/image/cover-image`).then(res => res.data);
}

/** 5) Get images */
export function getGalleryImages(farmId) {
  return client.get(`${BASE}/${farmId}/images/bulk-gallery`).then(res => res.data);
}

/** 6) Delete image */
export function deleteImage(farmId, imageId) {
  return client.delete(`${BASE}/${farmId}/image/${imageId}`).then(res => res.data);
}
